/*
 *
 * FormBuilder constants
 *
 */

export const ADD_FIELD = 'app/FormBuilder/ADD_FIELD';
export const ADD_STEP = 'app/FormBuilder/ADD_STEP';
export const BULK_TOGGLE_DROPDOWN_OPTIONS = 'app/FormBuilder/BULK_TOGGLE_DROPDOWN_OPTIONS';
export const CHANGE_CONSENT_STYLE = 'app/FormBuilder/CHANGE_CONSENT_STYLE';
export const CLEAR_FORM = 'app/FormBuilder/CLEAR_FORM';
export const COLLAPSE_ALL_FIELDS = 'app/FormBuilder/COLLAPSE_ALL_FIELDS';
export const DELETE_FIELD = 'app/FormBuilder/DELETE_FIELD';
export const FIELD_CLICKED = 'app/FormBuilder/FIELD_CLICKED';
export const FIELD_VALIDITY_CHANGED = 'app/Formbuilder/FIELD_VALIDITY_CHANGED';
export const EXPAND_ALL_FIELDS = 'app/FormBuilder/EXPAND_ALL_FIELDS';
export const LOAD_IN_PROGRESS = 'app/FormBuilder/LOAD_IN_PROGRESS';
export const RECEIVE_SF_FIELD_DATA = 'app/FormBuilder/RECEIVE_SF_FIELD_DATA';
export const REINITIALIZE_FIELD_VALIDITY = 'app/FormBuilder/REINITIALIZE_FIELD_VALIDITY';
export const REMOVE_ALL_USER_BRANCH_MEMBERSHIP = 'app/FormBuilder/REMOVE_ALL_USER_BRANCH_MEMBERSHIP';
export const REMOVE_STEP = 'app/FormBuilder/REMOVE_STEP';
export const REORDER_DROPDOWN = 'app/FormBuilder/REORDER_DROPDOWN';
export const REORDER_FIELD = 'app/FormBuilder/REORDER_FIELD';
export const SAVE_IN_PROGRESS = 'app/FormBuilder/SAVE_IN_PROGRESS';
export const SET_ACTIVE_FIELD = 'app/FormBuilder/SET_ACTIVE_FIELD';
export const SET_AVAILABLE_CREDENTIAL_TYPES = 'app/FormBuilder/SET_AVAILABLE_CREDENTIAL_TYPES';
export const SET_AVAILABLE_PROGRAMS = 'app/FormBuilder/SET_AVAILABLE_PROGRAMS';
export const SET_AVAILABLE_PROGRAMS_OF_STUDY = 'app/FormBuilder/SET_AVAILABLE_PROGRAMS_OF_STUDY';
export const SET_DIRTY = 'app/FormBuilder/SET_DIRTY';
export const SET_FIELD_INFERRED_STATE = 'app/FormBuilder/SET_FIELD_INFERRED_STATE';
export const SET_FORM = 'app/FormBuilder/SET_FORM';
export const SET_PROGRAM_FOR_FORM = 'app/FormBuilder/SET_PROGRAM_FOR_FORM';
export const SET_SUPPORTS_DEGREE_OFFERING = 'app/FormBuilder/SET_SUPPORTS_DEGREE_OFFERING';
export const SET_THANK_YOU_ROUTING = 'app/FormBuilder/SET_THANKYOU_ROUTING';
export const REFRESH_THANK_YOU_ROUTING = 'app/FormBuilder/REFRESH_THANKYOU_ROUTING';
export const SHOW_FORM_ERRORS = 'app/FormBuilder/SHOW_FORM_ERRORS';
export const TOGGLE_BRANCH_MEMBERSHIP = 'app/FormBuilder/TOGGLE_FIELD_BRANCH_MEMBERSHIP';
export const TOGGLE_BRANCHING = 'app/FormBuilder/TOGGLE_BRANCHING';
export const TOGGLE_THANK_YOU_ROUTING = 'app/FormBuilder/TOGGLE_THANKYOU_ROUTING';
export const UPDATE_DEFAULT_DEGREE_OFFERING = 'app/FormBuilder/UPDATE_DEFAULT_DEGREE_OFFERING';
export const TOGGLE_FIELD_COLLAPSED_STATE = 'app/FormBuilder/TOGGLE_FIELD_COLLAPSED_STATE';
export const UPDATE_FIELD_CONDITIONALITY = 'app/FormBuilder/UPDATE_FIELD_CONDITIONALITY';
export const UPDATE_FIELD_OVERRIDE_STATE = 'app/FormBuilder/UPDATE_FIELD_OVERRIDE_STATE';
export const UPDATE_FIELD_NAME = 'app/FormBuilder/UPDATE_FIELD_NAME';
export const UPDATE_FORM_VALUE = 'app/FormBuilder/UPDATE_FORM_VALUE';
export const UPDATE_FORM_VALIDITY = 'app/FormBuilder/UPDATE_FORM_VALIDITY';
export const UPDATE_PROGRAM_OF_STUDY = 'app/FormBuilder/UPDATE_PROGRAM_OF_STUDY';
export const UPDATE_UI_STATE = 'app/FormBuilder/UPDATE_UI_STATE';
